// @flow

import type { ChatBubbleMessage } from '@chatchamp/chatchamp-types'

// TODO; Dominik; 07.02.2024; function needs to move to ChatBubbleMessage.js
export function isVisibleMessage (message: ChatBubbleMessage<any>): boolean {
  return ['message', 'image', 'video', 'gallery', 'live_chat', 'products'].includes(message.type)
}

// TODO; Dominik; 07.02.2024; function needs to move to ChatBubbleMessage.js
export function isTypingMessage (message: ChatBubbleMessage<any>): boolean {
  return isTypingOnMessage(message) || isTypingOffMessage(message)
}

// TODO; Dominik; 07.02.2024; function needs to move to ChatBubbleMessage.js
export function isProductsMessage (message: ChatBubbleMessage<any>): boolean {
  if (!message) return false
  return message.type === 'products'
}

// TODO; Dominik; 07.02.2024; function needs to move to ChatBubbleMessage.js
export function isTypingOnMessage (message: ChatBubbleMessage<any>): boolean {
  if (!message) return false

  return message.type === 'trigger' &&
    message.content?.senderAction === 'typing_on'
}

// TODO; Dominik; 07.02.2024; function needs to move to ChatBubbleMessage.js
export function isTypingOffMessage (message: ChatBubbleMessage<any>): boolean {
  if (!message) return false

  return message.type === 'trigger' &&
    message.content?.senderAction === 'typing_off'
}

// TODO; Dominik; 07.02.2024; function needs to move to ChatBubbleMessage.js
export function isQuickReplyMessage (message: ChatBubbleMessage<any>): boolean {
  if (!message) return false

  return message.type === 'message' &&
    Array.isArray(message.content?.quick_replies)
}

// TODO; Dominik; 07.02.2024; function needs to move to ChatBubbleMessage.js
export function sortMessageByCreatedAt (msgA: Object, msgB: Object): any {
  const dateA = new Date(msgA.createdAt)
  const dateB = new Date(msgB.createdAt)

  return dateA - dateB
}
